export class CirabooksSideNavigationTree {
    static topItems = (parentId: string) => [
        {
            id: `${parentId}_1`,
            parentId,
            name: 'COMMUNITY_CIRABOOKS_HOME',
            path: '/cb/home',
            icon: '',
            text: 'CiraBooks Workspace',
            tooltip: 'CiraBooks Workspace',
            items: [],
            isWorkspace: true
        },
        {
            id: `${parentId}_2`,
            parentId,
            name: 'CB_CM',
            path: null,
            icon: '',
            text: 'Cash Management',
            tooltip: 'Cash Management',
            items: CirabooksSideNavigationTree.topCMItems(`${parentId}_2`)
        },
        {
            id: `${parentId}_3`,
            parentId,
            name: 'CB_AR',
            path: null,
            icon: '',
            text: 'Accounts Receivable',
            tooltip: 'Accounts Receivable',
            items: CirabooksSideNavigationTree.topARItems(`${parentId}_3`)
        },
        {
            id: `${parentId}_4`,
            parentId,
            name: 'CB_AP',
            path: null,
            icon: '',
            text: 'Accounts Payable',
            tooltip: 'Accounts Payable',
            items: CirabooksSideNavigationTree.topAPItems(`${parentId}_4`)
        },
        {
            id: `${parentId}_5`,
            parentId,
            name: 'CB_GL',
            path: null,
            icon: '',
            text: 'General Ledger',
            tooltip: 'General Ledger',
            items: CirabooksSideNavigationTree.topGLItems(`${parentId}_5`)
        },
        {
            id: `${parentId}_6`,
            parentId,
            name: 'CB_FR',
            path: null,
            icon: '',
            text: 'Financial Reports',
            tooltip: 'Financial Reports',
            items: CirabooksSideNavigationTree.topFRItems(`${parentId}_6`)
        },
        {
            id: `${parentId}_7`,
            parentId,
            name: 'CB_ENTITY',
            path: null,
            icon: '',
            text: 'CiraBooks Entity',
            tooltip: 'CiraBooks Entity',
            items: CirabooksSideNavigationTree.topECItems(`${parentId}_7`)
        }
    ];

    static communityItems = (parentId: string) => [
        {
            id: `${parentId}_1`,
            parentId,
            name: 'COMMUNITY_CIRABOOKS_HOME',
            path: '/cb/:communityId/home',
            icon: '',
            text: 'CiraBooks Workspace',
            tooltip: 'CiraBooks Workspace',
            items: [],
            isWorkspace: true
        },
        {
            id: `${parentId}_2`,
            parentId,
            name: 'CB_CM',
            path: null,
            icon: '',
            text: 'Cash Management',
            tooltip: 'Cash Management',
            items: CirabooksSideNavigationTree.communityCMItems(`${parentId}_2`)
        },
        {
            id: `${parentId}_3`,
            parentId,
            name: 'CB_AR',
            path: null,
            icon: '',
            text: 'Accounts Receivable',
            tooltip: 'Accounts Receivable',
            items: CirabooksSideNavigationTree.communityARItems(`${parentId}_3`)
        },
        {
            id: `${parentId}_4`,
            parentId,
            name: 'CB_AP',
            path: null,
            icon: '',
            text: 'Accounts Payable',
            tooltip: 'Accounts Payable',
            items: CirabooksSideNavigationTree.communityAPItems(`${parentId}_4`)
        },
        {
            id: `${parentId}_5`,
            parentId,
            name: 'CB_GL',
            path: null,
            icon: '',
            text: 'General Ledger',
            tooltip: 'General Ledger',
            items: CirabooksSideNavigationTree.communityGLItems(`${parentId}_5`)
        },
        {
            id: `${parentId}_6`,
            parentId,
            name: 'CB_FR',
            path: null,
            icon: '',
            text: 'Financial Reports',
            tooltip: 'Financial Reports',
            items: CirabooksSideNavigationTree.communityFRItems(`${parentId}_6`)
        },
        {
            id: `${parentId}_7`,
            parentId,
            name: 'CB_ENTITY',
            path: null,
            icon: '',
            text: 'CiraBooks Entity',
            tooltip: 'CiraBooks Entity',
            items: CirabooksSideNavigationTree.communityECItems(`${parentId}_7`)
        }
    ];

    static topCMItems = (parentId: string) => [
        {
            id: `${parentId}_1`,
            parentId,
            name: 'CB_CM_CASHRECEIPTS',
            path: '/cb/cm/cashreceipts',
            icon: '',
            text: 'Cash Receipts',
            tooltip: 'Cash Receipts',
            items: []
        },
        {
            id: `${parentId}_2`,
            parentId,
            name: 'CB_CM_DEPOSITS',
            path: '/cb/cm/deposits',
            icon: '',
            text: 'Deposits',
            tooltip: 'Deposits',
            items: []
        },
        {
            id: `${parentId}_3`,
            parentId,
            name: 'CB_CM_BATCHES',
            path: '/cb/cm/cmbatches',
            icon: '',
            text: 'CM Batches',
            tooltip: 'CM Batches',
            items: []
        },
        {
            id: `${parentId}_4`,
            parentId,
            name: 'CB_CM_MBS',
            path: '/gcb/cm/managebankstatement',
            icon: '',
            text: 'Manage Bank Statements',
            tooltip: 'Manage Bank Statements',
            items: []
        },
        {
            id: `${parentId}_5`,
            parentId,
            name: 'CB_CM_BANK_ACCOUNTS',
            path: '/cb/cm/bankaccounts',
            icon: '',
            text: 'Bank Accounts',
            tooltip: 'Bank Accounts',
            items: []
        },
        {
            id: `${parentId}_6`,
            parentId,
            name: 'CB_CM_PORTFOLIO_LOCKBOX_PAYMENT_FILE',
            path: '/cb/cm/lockboxpaymentfile',
            icon: '',
            text: 'Lockbox Payment File',
            tooltip: 'Lockbox Payment File',
            items: []
        },
        {
            id: `${parentId}_7`,
            parentId,
            name: 'CB_CM_BANK_RECONCILIATION',
            path: '/cb/cm/bankreconciliation',
            icon: '',
            text: 'Bank Reconciliation',
            tooltip: 'Bank Reconciliation',
            items: []
        },
        {
            id: `${parentId}_8`,
            parentId,
            name: 'CB_CM_CREATE_CASH_RECEIPT',
            path: '/cb/cm/postcashreceipts',
            icon: '',
            text: 'Create Cash Receipts',
            tooltip: 'Create Cash Receipts',
            items: []
        },
        {
            id: `${parentId}_9`,
            parentId,
            name: 'CB_CM_FUNDS_TRANSFER',
            path: '/cb/cm/fundstransfer',
            icon: '',
            text: 'Funds Transfer',
            tooltip: 'Funds Transfer',
            items: []
        },
        {
            id: `${parentId}_10`,
            parentId,
            name: 'CB_CM_UNMATCHED_TRANSACTIONS',
            path: '/cb/cm/unmatched-transactions',
            icon: '',
            text: 'Unmatched Transactions',
            tooltip: 'Unmatched Transactions',
            items: []
        }
    ];

    static topARItems = (parentId: string) => [
        {
            id: `${parentId}_1`,
            parentId,
            name: 'CB_AR_LEDGER',
            path: '/cb/ar/arledger',
            icon: '',
            text: 'AR Ledger',
            tooltip: 'AR Ledger',
            items: []
        },
        {
            id: `${parentId}_2`,
            parentId,
            name: 'CB_AR_BATCHES',
            path: '/cb/ar/arbatches',
            icon: '',
            text: 'AR Batches',
            tooltip: 'AR Batches',
            items: []
        },
        {
            id: `${parentId}_3`,
            parentId,
            name: 'CB_AR_CUSTOMER_AGING',
            path: '/cb/ar/customeraging',
            icon: '',
            text: 'Customer Aging',
            tooltip: 'Customer Aging',
            items: []
        },
        {
            id: `${parentId}_4`,
            parentId,
            name: 'CB_AR_INVOICE_ANALYSIS',
            path: '/cb/ar/arinvoiceanalysis',
            icon: '',
            text: 'AR Invoice Analysis',
            tooltip: 'AR Invoice Analysis',
            items: []
        },
        {
            id: `${parentId}_5`,
            parentId,
            name: 'CB_AR_LOT_PAYMENT_ALLOCATION',
            path: '/cb/ar/lotpaymentallocation',
            icon: '',
            text: 'Lot Payment Allocation',
            tooltip: 'Lot Payment Allocation',
            items: []
        },
        {
            id: `${parentId}_6`,
            parentId,
            name: 'CB_AR_COLLECTIONS',
            path: '/cb/ar/collections',
            icon: '',
            text: 'AR Collections',
            tooltip: 'AR Collections',
            items: []
        },
        {
            id: `${parentId}_7`,
            parentId,
            name: 'CB_AR_BUILDER_STATEMENTS',
            path: '/cb/ar/builderstatements',
            icon: '',
            text: 'Generate Builder Statements',
            tooltip: 'Generate Builder Statements',
            items: []
        },
        {
            id: `${parentId}_8`,
            parentId,
            name: 'CB_AR_ADD_PAYMENTS',
            path: '/cb/ar/createarpayments',
            icon: '',
            text: 'Add Payments',
            tooltip: 'Add Payments',
            items: []
        }
    ];

    static topAPItems = (parentId: string) => [
        {
            id: `${parentId}_1`,
            parentId,
            name: 'CB_AP_SUBMIT_INVOICE',
            path: '/workflow/paymentrequest',
            icon: '',
            text: 'Submit Invoice',
            tooltip: 'Submit Invoice/Payment Request',
            items: []
        },
        {
            id: `${parentId}_2`,
            parentId,
            name: 'SEARCH_INVOICES',
            path: '/workflow/searchinvoices',
            icon: '',
            text: 'Search Invoices',
            tooltip: 'Search Invoices',
            items: []
        },
        {
            id: `${parentId}_3`,
            parentId,
            name: 'CB_AP_EFT_MANAGEMENT',
            path: '/cb/ap/eftpaymentmanagement',
            icon: '',
            text: 'EFT Payment Management',
            tooltip: 'EFT Payment Management',
            items: []
        },
        {
            id: `${parentId}_4`,
            parentId,
            name: 'CB_AP_CHECK_PRINTING_MANAGEMENT',
            path: '/cb/ap/checkprintingmanagement',
            icon: '',
            text: 'Check Printing Management',
            tooltip: 'Check Printing Management',
            items: []
        },
        {
            id: `${parentId}_5`,
            parentId,
            name: 'CB_AP_APLEDGER',
            path: '/cb/ap/apledger',
            icon: '',
            text: 'AP Ledger',
            tooltip: 'AP Ledger',
            items: []
        },
        {
            id: `${parentId}_6`,
            parentId,
            name: 'CB_AP_VENDOR_AGING',
            path: '/cb/ap/vendoraging',
            icon: '',
            text: 'Vendor Aging',
            tooltip: 'Vendor Aging',
            items: []
        },
        {
            id: `${parentId}_7`,
            parentId,
            name: 'CB_AP_UNAPPLIED_PAYMENTS',
            path: '/cb/ap/unappliedpayments',
            icon: '',
            text: 'AP Unapplied Payments',
            tooltip: 'AP Unapplied Payments',
            items: []
        },
        {
            id: `${parentId}_8`,
            parentId,
            name: 'WF_REIMBURSEMENT_REQUEST',
            path: '/workflow/reimbursementrequest',
            icon: '',
            text: 'Reimbursement Request',
            tooltip: 'AAP Workflow Reimbursement Request',
            items: []
        },
        {
            id: `${parentId}_9`,
            parentId,
            name: 'CB_AP_BATCHES',
            path: '/cb/ap/apbatches',
            icon: '',
            text: 'AP Batches',
            tooltip: 'AP Batches',
            items: []
        },
        {
            id: `${parentId}_10`,
            parentId,
            name: 'CB_AP_VENDOR_MISSING_BILLS',
            path: '/workflow/vendormissingbills',
            icon: '',
            text: 'Vendor Missing Bills',
            tooltip: 'Vendor Missing Bills',
            items: []
        },
        {
            id: `${parentId}_11`,
            parentId,
            name: 'CB_AP_BILL_ANALYSIS',
            path: '/cb/ap/apbillanalysis',
            icon: '',
            text: 'AP Bill Analysis',
            tooltip: 'AP Bill Analysis',
            items: []
        },
        {
            id: `${parentId}_12`,
            parentId,
            name: 'WF_VENDOR_EDIT_QUEUE',
            path: '/workflow/managevendoredit',
            icon: '',
            text: 'Manage AAP Workflow Vendor Edit',
            tooltip: 'Manage AAP Workflow Vendor Edit',
            items: []
        },
        {
            id: `${parentId}_13`,
            parentId,
            name: 'CB_AP_SUBMITTED_INVOICE',
            path: '/workflow/submittedinvoices',
            icon: '',
            text: 'My Submitted Invoices',
            tooltip: 'My Submitted Invoices',
            items: []
        },
        {
            id: `${parentId}_14`,
            parentId,
            name: 'CB_AP_VENDOR_1099',
            path: '/cb/ap/vendor1099',
            icon: '',
            text: 'Vendor 1099',
            tooltip: 'Vendor 1099',
            items: []
        },
        {
            id: `${parentId}_15`,
            parentId,
            name: 'CB_AP_CONFIG_LOCAL_CHECK_PRINTING',
            path: '/cb/ap/localOfficeOnlyCheckPrinting',
            icon: '',
            text: 'Local Office Only Check Printing',
            tooltip: 'Local Office Only Check Printing',
            items: []
        },
        {
            id: `${parentId}_16`,
            parentId,
            name: 'CB_AP_MANAGE_VENDORS',
            path: '/cb/ap/manage-vendors',
            icon: '',
            text: 'Manage Vendors',
            tooltip: 'Manage Vendors',
            items: []
        }
    ];

    static topGLItems = (parentId: string) => [
        {
            id: `${parentId}_1`,
            parentId,
            name: 'CB_GL_TRIAL_BALANCE',
            path: '/cb/gl/trialbalance',
            icon: '',
            text: 'Trial Balance',
            tooltip: 'Trial Balance',
            items: []
        },
        {
            id: `${parentId}_2`,
            parentId,
            name: 'CB_GL_LEDGER',
            path: '/cb/gl/report',
            icon: '',
            text: 'General Ledger Report',
            tooltip: 'General Ledger Report',
            items: []
        },
        {
            id: `${parentId}_3`,
            parentId,
            name: 'CB_GL_JOURNAL_ENTRY',
            path: '/cb/gl/journalentries',
            icon: '',
            text: 'Journal Entries',
            tooltip: 'Journal Entries',
            items: []
        },
        {
            id: `${parentId}_4`,
            parentId,
            name: 'CB_GL_UPLOAD_JE',
            path: '/cb/gl/uploadjournalentry',
            icon: '',
            text: 'Upload JEs',
            tooltip: 'Upload JEs',
            items: []
        },
        {
            id: `${parentId}_5`,
            parentId,
            name: 'CB_GL_BUDGET',
            path: '/cb/gl/budget',
            icon: '',
            text: 'Budget',
            tooltip: 'Budget',
            items: []
        },
        {
            id: `${parentId}_6`,
            parentId,
            name: 'CB_GL_UPLOAD_BUDGETS',
            path: '/cb/gl/uploadbudgets',
            icon: '',
            text: 'Upload Budgets',
            tooltip: 'Upload Budgets',
            items: []
        },
        {
            id: `${parentId}_7`,
            parentId,
            name: 'CB_GL_JETEMPLATE',
            path: '/cb/gl/journalentrytemplate',
            icon: '',
            text: 'Journal Entry Templates',
            tooltip: 'Journal Entry Templates',
            items: []
        },
        {
            id: `${parentId}_8`,
            parentId,
            name: 'CB_GL_OPENCLOSEBOOKS',
            path: '/cb/gl/open-close-books',
            icon: '',
            text: 'Open / Close Books',
            tooltip: 'Open / Close Books',
            items: []
        }
    ];

    static topFRItems = (parentId: string) => [
        {
            id: `${parentId}_1`,
            parentId,
            name: 'CB_FR_ACTUAL_VS_BUDGET',
            path: '/cb/fr/actualvsbudget',
            icon: '',
            text: 'Actual vs Budget',
            tooltip: 'Actual vs Budget',
            items: []
        },
        {
            id: `${parentId}_2`,
            parentId,
            name: 'CB_FR_FINANCIAL_SUMMARY',
            path: '/cb/fr/financialsummary',
            icon: '',
            text: 'Financial Summary',
            tooltip: 'Financial Summary',
            items: []
        },
        {
            id: `${parentId}_3`,
            parentId,
            name: 'CB_FR_BENCHMARK_REPORT',
            path: '/cb/fr/benchmarkreport',
            icon: '',
            text: 'Benchmark Report',
            tooltip: 'Benchmark Report',
            items: []
        }
    ];

    static topECItems = (parentId: string) => [
        {
            id: `${parentId}_1`,
            parentId,
            name: 'CB_ENTITY_CONFIGURATION',
            path: '/cb/entity/configuration',
            icon: '',
            text: 'Configuration',
            tooltip: 'Configuration',
            items: []
        },
        {
            id: `${parentId}_2`,
            parentId,
            name: 'CB_ENTITY_AUDIT_LOG',
            path: '/cb/entity/audit-log',
            icon: '',
            text: 'Audit Log',
            tooltip: 'Audit Log',
            items: []
        }
    ];

    static communityCMItems = (parentId: string) => [
        {
            id: `${parentId}_1`,
            parentId,
            name: 'CB_CM_CASHRECEIPTS',
            path: '/cb/:communityId/cm/cashreceipts',
            icon: '',
            text: 'Cash Receipts',
            tooltip: 'Cash Receipts',
            items: []
        },
        {
            id: `${parentId}_2`,
            parentId,
            name: 'CB_CM_DEPOSITS',
            path: '/cb/:communityId/cm/deposits',
            icon: '',
            text: 'Deposits',
            tooltip: 'Deposits',
            items: []
        },
        {
            id: `${parentId}_3`,
            parentId,
            name: 'CB_CM_BATCHES',
            path: '/cb/:communityId/cm/cmbatches',
            icon: '',
            text: 'CM Batches',
            tooltip: 'CM Batches',
            items: []
        },
        {
            id: `${parentId}_4`,
            parentId,
            name: 'CB_CM_BANK_ACCOUNTS',
            path: '/cb/:communityId/cm/bankaccounts',
            icon: '',
            text: 'Bank Accounts',
            tooltip: 'Bank Accounts',
            items: []
        },
        {
            id: `${parentId}_5`,
            parentId,
            name: 'CB_CM_LOCKBOX_PAYMENT_FILE',
            path: '/cb/:communityId/cm/lockboxpaymentfile',
            icon: '',
            text: 'Lockbox Payment File',
            tooltip: 'Lockbox Payment File',
            items: []
        },
        {
            id: `${parentId}_6`,
            parentId,
            name: 'CB_CM_BANK_RECONCILIATION',
            path: '/cb/:communityId/cm/bankreconciliation',
            icon: '',
            text: 'Bank Reconciliation',
            tooltip: 'Bank Reconciliation',
            items: []
        },
        {
            id: `${parentId}_7`,
            parentId,
            name: 'CB_CM_POST_CASH_RECEIPT',
            path: '/cb/:communityId/cm/postcashreceipts',
            icon: '',
            text: 'Create Cash Receipts',
            tooltip: 'Create Cash Receipts',
            items: []
        },
        {
            id: `${parentId}_8`,
            parentId,
            name: 'CB_CM_FUNDS_TRANSFER',
            path: '/cb/:communityId/cm/fundstransfer',
            icon: '',
            text: 'Funds Transfer',
            tooltip: 'Funds Transfer',
            items: []
        },
        {
            id: `${parentId}_9`,
            parentId,
            name: 'CB_CM_UNMATCHED_TRANSACTIONS',
            path: '/cb/:communityId/cm/unmatched-transactions',
            icon: '',
            text: 'Unmatched Transactions',
            tooltip: 'Unmatched Transactions',
            items: []
        }
    ];

    static communityARItems = (parentId: string) => [
        {
            id: `${parentId}_1`,
            parentId,
            name: 'CB_AR_LEDGER',
            path: '/cb/:communityId/ar/arledger',
            icon: '',
            text: 'AR Ledger',
            tooltip: 'AR Ledger',
            items: []
        },
        {
            id: `${parentId}_2`,
            parentId,
            name: 'CB_AR_BATCHES',
            path: '/cb/:communityId/ar/arbatches',
            icon: '',
            text: 'AR Batches',
            tooltip: 'AR Batches',
            items: []
        },
        {
            id: `${parentId}_3`,
            parentId,
            name: 'CB_AR_CUSTOMER_AGING',
            path: '/cb/:communityId/ar/customeraging',
            icon: '',
            text: 'Customer Aging',
            tooltip: 'Customer Aging',
            items: []
        },
        {
            id: `${parentId}_4`,
            parentId,
            name: 'CB_AR_INVOICE_ANALYSIS',
            path: '/cb/:communityId/ar/arinvoiceanalysis',
            icon: '',
            text: 'AR Invoice Analysis',
            tooltip: 'AR Invoice Analysis',
            items: []
        },
        {
            id: `${parentId}_5`,
            parentId,
            name: 'CB_AR_MASS_UPLOAD',
            path: '/cb/:communityId/ar/massupload',
            icon: '',
            text: 'Mass Invoice / Adjustment Upload',
            tooltip: 'Mass Invoice / Adjustment Upload',
            items: []
        },
        {
            id: `${parentId}_6`,
            parentId,
            name: 'COMMUNITY_DELINQUENCY_DETAIL',
            path: '/community/:communityId/delinquency-detail',
            icon: '',
            text: 'Delinquency Detail',
            tooltip: 'Delinquency Detail',
            items: []
        },
        {
            id: `${parentId}_7`,
            parentId,
            name: 'ATTORNEY_REFERRAL_TOOL',
            path: '/community/:communityId/attorney-referral',
            icon: '',
            text: 'Attorney Referral Tool',
            tooltip: 'Attorney Referral Tool',
            items: []
        },
        {
            id: `${parentId}_8`,
            parentId,
            name: 'COMMUNITY_CERTIFIED_COLLECTION_NOTICES',
            path: '/community/:communityId/certified-collection-notices',
            icon: '',
            text: 'Certified Collection Notices',
            tooltip: 'Certified Collection Notices',
            items: []
        },
        {
            id: `${parentId}_9`,
            parentId,
            name: 'CB_BILLING_RULE_ASSIGNMENT',
            path: '/cb/:communityId/ar/billingruleassignments',
            icon: '',
            text: 'Billing Rule Assignments',
            tooltip: 'Billing Rule Assignments',
            items: []
        },
        {
            id: `${parentId}_10`,
            parentId,
            name: 'CB_ASSESSMENT_RULE_ASSIGNMENT',
            path: '/cb/:communityId/ar/assessmentrulesassignments',
            icon: '',
            text: 'Assessment Rule Assignments',
            tooltip: 'Assessment Rule Assignments',
            items: []
        },
        {
            id: `${parentId}_11`,
            parentId,
            name: 'CB_AR_ADD_PAYMENTS',
            path: '/cb/:communityId/ar/createarpayments',
            icon: '',
            text: 'Add Payments',
            tooltip: 'Add Payments',
            items: []
        },
        {
            id: `${parentId}_12`,
            parentId,
            name: 'CB_AR_LOT_PAYMENT_ALLOCATION',
            path: '/cb/:communityId/ar/lotpaymentallocation',
            icon: '',
            text: 'Lot Payment Allocation',
            tooltip: 'Lot Payment Allocation',
            items: []
        },
        {
            id: `${parentId}_13`,
            parentId,
            name: 'CB_AR_BUILDER_STATEMENTS',
            path: '/cb/:communityId/ar/builderstatements',
            icon: '',
            text: 'Generate Builder Statements',
            tooltip: 'Generate Builder Statements',
            items: []
        },
        {
            id: `${parentId}_14`,
            parentId,
            name: 'CB_AR_COLLECTIONS',
            path: '/cb/:communityId/ar/collections',
            icon: '',
            text: 'AR Collection',
            tooltip: 'AR Collection',
            items: []
        },
        {
            id: `${parentId}_15`,
            parentId,
            name: 'ASSESSMENT_RULES',
            path: '/cb/:communityId/ar/assessment',
            icon: '',
            text: 'Assessment Rules',
            tooltip: 'Assessment Rules',
            items: []
        },
        {
            id: `${parentId}_16`,
            parentId,
            name: 'BILLING_RULES',
            path: '/cb/:communityId/ar/billingrules',
            icon: '',
            text: 'Billing Rules',
            tooltip: 'Billing Rules',
            items: []
        },
        {
            id: `${parentId}_17`,
            parentId,
            name: 'BILLING_LATE_FEE_RULES',
            path: '/cb/:communityId/ar/billinglatefeerules',
            icon: '',
            text: 'Billing Late Fee Rules',
            tooltip: 'Billing Late Fee Rules',
            items: []
        },
        {
            id: `${parentId}_18`,
            parentId,
            name: 'AR_TRANSITION_REPORTS',
            path: null,
            icon: '',
            text: 'Transition AR',
            tooltip: 'Transition AR',
            items: [
                {
                    id: `${parentId}_18_1`,
                    parentId: `${parentId}_18`,
                    name: 'AR_TRANSITION_REPORTS_ALL_BALANCES',
                    path: '/cb/:communityId/ar/transitionreports/all-balances',
                    icon: '',
                    text: 'All Balances',
                    tooltip: 'All Balances',
                    items: []
                },
                {
                    id: `${parentId}_18_2`,
                    parentId: `${parentId}_18`,
                    name: 'AR_TRANSITION_REPORTS_CREDIT_BALANCES',
                    path: '/cb/:communityId/ar/transitionreports/credit-balances',
                    icon: '',
                    text: 'Credit Balances',
                    tooltip: 'Credit Balances',
                    items: []
                },
                {
                    id: `${parentId}_18_3`,
                    parentId: `${parentId}_18`,
                    name: 'AR_TRANSITION_REPORTS_DEBIT_BALANCES',
                    path: '/cb/:communityId/ar/transitionreports/debit-balances',
                    icon: '',
                    text: 'Debit Balances',
                    tooltip: 'Debit Balances',
                    items: []
                },
                {
                    id: `${parentId}_18_4`,
                    parentId: `${parentId}_18`,
                    name: 'AR_TRANSITION_REPORTS_DEBIT/CREDIT_BALANCES',
                    path: '/cb/:communityId/ar/transitionreports/debit-credit-balances',
                    icon: '',
                    text: 'Debit/Credit Balances',
                    tooltip: 'Debit/Credit Balances',
                    items: []
                },
                {
                    id: `${parentId}_18_5`,
                    parentId: `${parentId}_18`,
                    name: 'AR_TRANSITION_REPORTS_ZERO_BALANCES',
                    path: '/cb/:communityId/ar/transitionreports/zero-balances',
                    icon: '',
                    text: 'Zero Balances',
                    tooltip: 'Zero Balances',
                    items: []
                }
            ]
        },
        {
            id: `${parentId}_19`,
            parentId,
            name: 'CB_AR_AGING_SUMMARY_REPORT',
            path: '/community/:communityId/aragingsummary',
            icon: '',
            text: 'AR Aging Summary',
            tooltip: 'AR Aging Summary',
            items: []
        },
        {
            id: `${parentId}_20`,
            parentId,
            name: 'BILLING_CONVEYANCE_AND_ANNUAL_DISCOUNT_RULE',
            path: '/cb/:communityId/ar/conveyance-discount',
            icon: '',
            text: 'Conveyance & Discount Rules',
            tooltip: 'Conveyance & Discount Rules',
            items: []
        }
    ];

    static communityAPItems = (parentId: string) => [
        {
            id: `${parentId}_1`,
            parentId,
            name: 'CB_AP_SUBMIT_INVOICE',
            path: '/workflow/:communityId/paymentrequest',
            icon: '',
            text: 'Submit Invoice',
            tooltip: 'Submit Invoice/Payment Request',
            items: []
        },
        {
            id: `${parentId}_2`,
            parentId,
            name: 'SEARCH_INVOICES',
            path: '/workflow/:communityId/searchinvoices',
            icon: '',
            text: 'Search Invoices',
            tooltip: 'Search Invoices',
            items: []
        },
        {
            id: `${parentId}_3`,
            parentId,
            name: 'CB_AP_EFT_MANAGEMENT',
            path: '/cb/:communityId/ap/eftpaymentmanagement',
            icon: '',
            text: 'EFT Payment Management',
            tooltip: 'EFT Payment Management',
            items: []
        },
        {
            id: `${parentId}_4`,
            parentId,
            name: 'CB_AP_CHECK_PRINTING_MANAGEMENT',
            path: '/cb/:communityId/ap/checkprintingmanagement',
            icon: '',
            text: 'Check Printing Management',
            tooltip: 'Check Printing Management',
            items: []
        },
        {
            id: `${parentId}_5`,
            parentId,
            name: 'CB_AP_APLEDGER',
            path: '/cb/:communityId/ap/apledger',
            icon: '',
            text: 'AP Ledger',
            tooltip: 'AP Ledger',
            items: []
        },
        {
            id: `${parentId}_6`,
            parentId,
            name: 'CB_AP_VENDOR_AGING',
            path: '/cb/:communityId/ap/vendoraging',
            icon: '',
            text: 'Vendor Aging',
            tooltip: 'Vendor Aging',
            items: []
        },
        {
            id: `${parentId}_7`,
            parentId,
            name: 'CB_AP_UNAPPLIED_PAYMENTS',
            path: '/cb/:communityId/ap/unappliedpayments',
            icon: '',
            text: 'AP Unapplied Payments',
            tooltip: 'AP Unapplied Payments',
            items: []
        },
        {
            id: `${parentId}_8`,
            parentId,
            name: 'WF_REIMBURSEMENT_REQUEST',
            path: '/workflow/:communityId/reimbursementrequest',
            icon: '',
            text: 'Reimbursement Request',
            tooltip: 'AAP Workflow Reimbursement Request',
            items: []
        },
        {
            id: `${parentId}_9`,
            parentId,
            name: 'CB_AP_BATCHES',
            path: '/cb/:communityId/ap/apbatches',
            icon: '',
            text: 'AP Batches',
            tooltip: 'AP Batches',
            items: []
        },
        {
            id: `${parentId}_10`,
            parentId,
            name: 'CB_AP_VENDOR_MISSING_BILLS',
            path: '/workflow/:communityId/vendormissingbills',
            icon: '',
            text: 'Vendor Missing Bills',
            tooltip: 'Vendor Missing Bills',
            items: []
        },
        {
            id: `${parentId}_11`,
            parentId,
            name: 'CB_AP_BILL_ANALYSIS',
            path: '/cb/:communityId/ap/apbillanalysis',
            icon: '',
            text: 'AP Bill Analysis',
            tooltip: 'AP Bill Analysis',
            items: []
        },
        {
            id: `${parentId}_12`,
            parentId,
            name: 'CB_AP_OPEN_AP',
            path: '/cb/:communityId/ap/openap',
            icon: '',
            text: 'Open AP',
            tooltip: 'Open AP',
            items: []
        },
        {
            id: `${parentId}_13`,
            parentId,
            name: 'WF_VENDOR_EDIT_QUEUE',
            path: '/workflow/:communityId/managevendoredit',
            icon: '',
            text: 'Manage AAP Workflow Vendor Edit',
            tooltip: 'Manage AAP Workflow Vendor Edit',
            items: []
        },
        {
            id: `${parentId}_14`,
            parentId,
            name: 'CB_AP_EXPENSE_DETAIL',
            path: '/cb/:communityId/ap/expensedetail',
            icon: '',
            text: 'AP Expense Detail',
            tooltip: 'AP Expense Detail',
            items: []
        },
        {
            id: `${parentId}_15`,
            parentId,
            name: 'CB_AP_SUBMITTED_INVOICE',
            path: '/workflow/:communityId/submittedinvoices',
            icon: '',
            text: 'My Submitted Invoices',
            tooltip: 'My Submitted Invoices',
            items: []
        },
        {
            id: `${parentId}_16`,
            parentId,
            name: 'CB_AP_MANAGE_VENDORS',
            path: '/cb/:communityId/ap/manage-vendors',
            icon: '',
            text: 'Manage Vendors',
            tooltip: 'Manage Vendors',
            items: []
        }
    ];

    static communityGLItems = (parentId: string) => [
        {
            id: `${parentId}_1`,
            parentId,
            name: 'CB_GL_TRIAL_BALANCE',
            path: '/cb/:communityId/gl/trialbalance',
            icon: '',
            text: 'Trial Balance',
            tooltip: 'Trial Balance',
            items: []
        },
        {
            id: `${parentId}_2`,
            parentId,
            name: 'CB_GL_LEDGER',
            path: '/cb/:communityId/gl/report',
            icon: '',
            text: 'General Ledger Report',
            tooltip: 'General Ledger Report',
            items: []
        },
        {
            id: `${parentId}_3`,
            parentId,
            name: 'CB_GL_JOURNAL_ENTRY',
            path: '/cb/:communityId/gl/journalentries',
            icon: '',
            text: 'Journal Entries',
            tooltip: 'Journal Entries',
            items: []
        },
        {
            id: `${parentId}_4`,
            parentId,
            name: 'CB_GL_UPLOAD_JE',
            path: '/cb/:communityId/gl/uploadjournalentry',
            icon: '',
            text: 'Upload JEs',
            tooltip: 'Upload JEs',
            items: []
        },
        {
            id: `${parentId}_5`,
            parentId,
            name: 'CB_GL_BUDGET',
            path: '/cb/:communityId/gl/budget',
            icon: '',
            text: 'Budget',
            tooltip: 'Budget',
            items: []
        },
        {
            id: `${parentId}_6`,
            parentId,
            name: 'CB_GL_UPLOAD_BUDGETS',
            path: '/cb/:communityId/gl/uploadbudgets',
            icon: '',
            text: 'Upload Budgets',
            tooltip: 'Upload Budgets',
            items: []
        },
        {
            id: `${parentId}_7`,
            parentId,
            name: 'CB_GL_JETEMPLATE',
            path: '/cb/:communityId/gl/journalentrytemplate',
            icon: '',
            text: 'Journal Entry Templates',
            tooltip: 'Journal Entry Templates',
            items: []
        },
        {
            id: `${parentId}_8`,
            parentId,
            name: 'CB_GL_OPENCLOSEBOOKS',
            path: '/cb/:communityId/gl/open-close-books',
            icon: '',
            text: 'Open / Close Books',
            tooltip: 'Open / Close Books',
            items: []
        }
    ];

    static communityFRItems = (parentId: string) => [
        {
            id: `${parentId}_1`,
            parentId,
            name: 'CB_FR_ACTUAL_VS_BUDGET',
            path: '/cb/:communityId/fr/actualvsbudget',
            icon: '',
            text: 'Actual vs Budget',
            tooltip: 'Actual vs Budget',
            items: []
        },
        {
            id: `${parentId}_2`,
            parentId,
            name: 'CB_FR_FINANCIAL_SUMMARY',
            path: '/cb/:communityId/fr/financialsummary',
            icon: '',
            text: 'Financial Summary',
            tooltip: 'Financial Summary',
            items: []
        },
        {
            id: `${parentId}_3`,
            parentId,
            name: 'CB_FR_BENCHMARK_REPORT',
            path: '/cb/:communityId/fr/benchmarkreport',
            icon: '',
            text: 'Benchmark Report',
            tooltip: 'Benchmark Report',
            items: []
        }
    ];

    static communityECItems = (parentId: string) => [
        {
            id: `${parentId}_1`,
            parentId,
            name: 'CB_ENTITY_CONFIGURATION',
            path: '/cb/:communityId/entity/configuration',
            icon: '',
            text: 'Configuration',
            tooltip: 'Configuration',
            items: []
        },
        {
            id: `${parentId}_2`,
            parentId,
            name: 'CB_ENTITY_AUDIT_LOG',
            path: '/cb/:communityId/entity/audit-log',
            icon: '',
            text: 'Audit Log',
            tooltip: 'Audit Log',
            items: []
        }
    ];
}
